import React, { useEffect, useState } from "react";
import { Link, Switch, Route, useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';
import { logoff } from "services/oauth";
import routes from "admin-routes.js";
import UserIcon from '@rsuite/icons/legacy/User';
import SettingsIcon from '@rsuite/icons/legacy/Gear';
import UsersIcon from '@rsuite/icons/legacy/PeopleGroup';
import RefreshIcon from '@rsuite/icons/legacy/Refresh';
import Settings from "views/admin/settings";
import Users from "views/admin/users";
import Profile from "views/admin/profile";
import RingLoader from 'react-spinners/PuffLoader'
import { useClearCache } from 'react-clear-cache';

import {
    Container,
    Dropdown,
    Header,
    Content,
    Divider,
    IconButton,
    Modal,
    Nav,
    Navbar,
    Panel,
    Popover,
    Stack,
    Whisper
} from 'rsuite';
import ResponsiveNav from '@rsuite/responsive-nav';
import { Icon } from '@rsuite/icons';
import { MainLogo } from "../utils/icons";
require('assets/css/adminLayout.css');

function Admin() {
    console.log("***************** Admin *****************");
    const user = useSelector(state => state.auth.user); //JSON.parse(JSON.stringify(useSelector(state => state.auth.user)));
    const site = useSelector(state => state.site);
    const params = useSelector(state => state.params);
    const history = useHistory();
    const [working, setWorking] = useState(false);
    const [iconLogo, setIconLogo] = useState(null);
    const abortController = new AbortController();
    const activeRoute = (routeName) => {
        return window.location.pathname === routeName ? "rs-navbar-item-active" : "";
    };
    const { isLatestVersion, emptyCacheStorage } = useClearCache();
    const createLinks = (routes, keyCount) => {
        let count = keyCount || 0;
        return routes.filter((prop, index) => {
            if (prop.role === '') return true;
            if (Array.isArray(user.role)) {
                return user.role.some(r => prop.role.split(',').includes(r));
            } else if (typeof user.role === 'string') {
                return prop.role.split(',').includes(user.role);
            }
            return true;
        }).map((prop, key) => {
            count++;
            if (prop.redirect) {
                return null;
            }
            if (prop.collapse) {
                return (
                    <ResponsiveNav.Menu title={prop.name}>
                        {createLinks(prop.views, count--)}
                    </ResponsiveNav.Menu>
                );
            }
            return (
                <ResponsiveNav.Item
                    className={activeRoute(prop.layout + prop.path)}
                    to={prop.layout + prop.path}
                    eventKey={'item_' + count}
                    key={count}
                    icon={prop.icon}
                    as={Link}>{prop.name}</ResponsiveNav.Item>
            );
        });
    };
    const getRoutes = (routes) => {
        return routes.filter((prop, index) => {
            if (prop.role === '' || prop.role === 'map') return true;
            if (Array.isArray(user.role)) {
                return user.role.some(r => prop.role.split(',').includes(r));
            } else if (typeof user.role === 'string') {
                return prop.role.split(',').includes(user.role);
            }
            return false;
        }).map((prop, key) => {
            if (prop.collapse) {
                return getRoutes(prop.views);
            }
            if (prop.layout === "/admin") {
                return (
                    <Route
                        path={prop.layout + prop.path}
                        key={key}
                        render={(props) => <prop.component {...props} setWorking={setWorking} />}
                    />
                );
            } else {
                return null;
            }
        });
    };

    const UserPopover = React.forwardRef(({ onSelect, ...rest }, ref) => (
        <Popover ref={ref} {...rest} full title={(<Panel>{user.name}</Panel>)}>
            <Dropdown.Menu onSelect={onSelect} >
                <Dropdown.Item style={{ minWidth: 200 }} eventKey={6}>Perfil de usuario</Dropdown.Item>
                <Dropdown.Item divider />
                <Dropdown.Item eventKey={7}>Cerrar sesi&oacute;n</Dropdown.Item>
            </Dropdown.Menu>
        </Popover>
    ));

    useEffect(() => {
        console.log('Admin Layout ENTER');
        console.log(user);

        return () => (console.log('Admin Layout EXIT'))
    }, []);

    useEffect(() => {
        site.site != null ? (fetch(site.site.apiServer + '/catalogo/res/logo').then((r) => r.text()).then((r) => setIconLogo(r)).catch(() => { })) : void (0);
        return () => abortController.abort();
    }, [site]);

    const refPopOver = React.useRef();

    return (
        <>
            <Container>
                <Header>
                    <Navbar appearance="inverse">
                        <Navbar.Brand>
                            {iconLogo != null && <div className="brand-logo" dangerouslySetInnerHTML={{ __html: iconLogo }} />}
                            <span>{params.brand ? params.brand.name : ''}</span>
                        </Navbar.Brand>
                        <Nav><Divider vertical style={{ height: "40px", marginTop: "7px" }} /></Nav>
                        <div>
                            <ResponsiveNav>{createLinks(routes, 0)}</ResponsiveNav>
                        </div>
                        <div style={{ padding: 7, float: "right", position:"relative" }}>
                            <Stack spacing={5}>
                                {!isLatestVersion && (
                                    <IconButton title="Actualizar" appearance="primary" size="lg" icon={<RefreshIcon />} onClick={() => { history.push('/admin/users') }} />
                                )}
                                {user.role.includes('admin') && (
                                    <IconButton title="Usuarios" appearance="primary" size="lg" icon={<UsersIcon />} onClick={() => { history.push('/admin/users') }}
                                        style={{ backgroundColor: window.location.pathname === "/admin/users" ? "var(--rs-navbar-inverse-selected-bg)" : "inherit" }} />)}
                                {user.role.includes('admin') && (
                                    <IconButton title="Ajustes" appearance="primary" size="lg" icon={<SettingsIcon />} onClick={() => { history.push('/admin/settings') }}
                                        style={{ backgroundColor: window.location.pathname === "/admin/settings" ? "var(--rs-navbar-inverse-selected-bg)" : "inherit" }} />)}
                                <Whisper placement="bottomEnd" controlId="control-id-with-dropdown-2" trigger="click" ref={refPopOver}
                                    speaker={<UserPopover className="profile-pop" onSelect={(k) => refPopOver.current.close() || (k === 6 ? history.push('/admin/profile') : (k === 7 ? logoff() : void (0)))} />}>
                                    <IconButton appearance="primary" size="lg" icon={<UserIcon />} />
                                </Whisper>
                            </Stack>
                        </div>
                    </Navbar>
                </Header>
                <Content style={{ padding: "20px" }}>
                    <Switch>
                        {getRoutes(routes)}
                        <Route
                            path="/admin/settings"
                            key="settings"
                            render={(props) => <Settings {...props} setWorking={setWorking} />} />
                        <Route
                            path="/admin/users"
                            key="settings"
                            render={(props) => <Users {...props} setWorking={setWorking} />} />
                        <Route
                            path="/admin/profile"
                            key="settings"
                            render={(props) => <Profile {...props} setWorking={setWorking} />} />
                    </Switch>
                </Content>
                <Modal backdrop="static" keyboard={false} open={working} size="xs" className="custom-working" backdropClassName="custom-working-backdrop">
                    <Modal.Body style={{ textAlign: "center", height: 80 }}>
                        <RingLoader color={"#ffffff"} />
                    </Modal.Body>
                </Modal>
            </Container>
        </>
    );
}
export default Admin;